function o(o,e,t){const a=o.options.get("projection").toGlobalPixels(e,t.getZoom()),l=t.converter.globalToPage(a);return{lat:e[0],lng:e[1],pageX:l[0],pageY:l[1]}}export{o as default};
//# sourceMappingURL=getObjectCoordinates.js.map
